import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthGuardService } from './services/auth-guard.service';
import { RegisterComponent } from './register/register.component';
import { TRANSLATE } from '../shared/classes/translatable';
import { AclGuardService } from './services/acl-guard.service';
import { PasswordOublieComponent } from './password-oublie/password-oublie.component';
import { ValidationFacturesComponent } from './validation-factures/validation-factures.component';

const routes: Routes = [
    {
        path: 'dashboard',
        loadChildren: '../dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: {breadcrumb: TRANSLATE('Dashboard')}
    },
    {
        path: '',
        loadChildren: '../dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        data: {breadcrumb: TRANSLATE('Dashboard')}
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {breadcrumb: TRANSLATE('Connexion')}
    },
    {
        path: 'reset-password',
        component: LoginComponent,
        data: {breadcrumb: TRANSLATE('Validation de facture fournisseur')}
    },
    {
        path: 'reset-password/:token',
        component: LoginComponent,
        data: {breadcrumb: TRANSLATE('Validation de facture fournisseur')}
    },
    {
        path: 'register',
        component: RegisterComponent,
        data: {breadcrumb: TRANSLATE('Inscription')}
    },
    {
        path: 'identite',
        loadChildren: '../identite/identite.module#IdentiteModule',
        canActivate: [AuthGuardService],
        data: {breadcrumb: TRANSLATE('Identités'), acl: 'identites'}
    },
    {
        path: 'infrastructure',
        loadChildren: '../infrastructure/infrastructure.module#InfrastructureModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Infrastructures')}
    },
    {
        path: 'configuration',
        loadChildren: '../configuration/configuration.module#ConfigurationModule',
        canActivate: [AuthGuardService],
        data: {breadcrumb: TRANSLATE('Configuration'), acl: 'configuration'}
    },
    {
        path: 'facturation',
        loadChildren: '../facturation/facturation.module#FacturationModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Facturation'), acl: 'facturation'}
    },
    {
        path: 'agence',
        loadChildren: '../agence/agence.module#AgenceModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Agence'), acl: 'agence'}
    },
    {
        path: 'agenda',
        loadChildren: '../agenda/agenda.module#AgendaModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Agenda'), acl: 'agenda'}
    },
    {
        path: 'mailing',
        loadChildren: '../mailing/mailing.module#MailingModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Emails'), acl: 'mailing'}
    },
    {
        path: 'recherche',
        loadChildren: '../recherche/recherche.module#RechercheModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Recherche'), acl: 'recherche'}
    },
    {
        path: 'tache',
        loadChildren: '../tache/tache.module#TacheModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Tâches')}
    },
    {
        path: 'etape',
        loadChildren: '../etape/etape.module#EtapeModule',
        canActivate: [AuthGuardService, AclGuardService],
        data: {breadcrumb: TRANSLATE('Etape'), acl: 'etape'}
    },
    {
        path: 'validation-facture',
        component: ValidationFacturesComponent,
        data: {breadcrumb: TRANSLATE('Mot de passe oublié')}
    },
    {
        path: 'validation-facture/:token',
        component: ValidationFacturesComponent,
        data: {breadcrumb: TRANSLATE('Mot de passe oublié')}
    },
    {
        path: '**',
        component: NotFoundComponent,
        data: {breadcrumb: '404'}
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class CoreRoutingModule { }
